// CSV import/export utility functions

/**
 * Export panels to CSV file
 * @param {Array} panels - Array of panel objects
 * @param {Function} handlePanelsMenuClose - Function to close the panels menu
 */
export const handleExportPanelsCsv = (panels, handlePanelsMenuClose) => {
  const headers = ['Enabled', 'Width', 'Length', 'Quantity', 'Material Type', 'Label', 'Grain Direction'];
  const rows = panels.map(panel => [
    panel.enabled,
    panel.width,
    panel.length,
    panel.quantity,
    panel.materialType || '',
    panel.label || '',
    panel.grainDirection
  ]);
  const csv = [headers, ...rows].map(row => row.join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'panels.csv';
  a.click();
  window.URL.revokeObjectURL(url);
  handlePanelsMenuClose();
};

/**
 * Import panels from CSV file
 * @param {Event} event - File input change event
 * @param {Function} setPanels - State setter for panels
 * @param {Function} handlePanelsMenuClose - Function to close the panels menu
 */
export const handleImportPanelsCsv = (event, setPanels, handlePanelsMenuClose) => {
  const file = event.target.files[0];
  if (!file) return;
  
  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const text = e.target.result;
      const lines = text.split('\n').filter(line => line.trim());
      const data = lines.slice(1).map(line => {
        const values = line.split(',');
        return {
          enabled: values[0] === 'true',
          width: values[1] || '',
          length: values[2] || '',
          quantity: values[3] || '',
          materialType: values[4] || '',
          label: values[5] || '',
          grainDirection: values[6] || 'either'
        };
      });
      setPanels(data.length > 0 ? data : [{ width: '', length: '', quantity: '', materialType: '', label: '', enabled: true, grainDirection: 'either' }]);
    } catch (error) {
      alert('Error importing CSV: ' + error.message);
    }
  };
  reader.readAsText(file);
  event.target.value = null; // Reset input
  handlePanelsMenuClose();
};

/**
 * Export stock sheets to CSV file
 * @param {Array} stockSheets - Array of stock sheet objects
 * @param {Function} handleStockMenuClose - Function to close the stock menu
 */
export const handleExportStockCsv = (stockSheets, handleStockMenuClose) => {
  const headers = ['Enabled', 'Width', 'Length', 'Quantity', 'Material Type', 'Grain Direction'];
  const rows = stockSheets.map(stock => [
    stock.enabled,
    stock.width,
    stock.length,
    stock.quantity,
    stock.materialType || '',
    stock.grainDirection
  ]);
  const csv = [headers, ...rows].map(row => row.join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'stock_sheets.csv';
  a.click();
  window.URL.revokeObjectURL(url);
  handleStockMenuClose();
};

/**
 * Import stock sheets from CSV file
 * @param {Event} event - File input change event
 * @param {Function} setStockSheets - State setter for stock sheets
 * @param {Function} handleStockMenuClose - Function to close the stock menu
 */
export const handleImportStockCsv = (event, setStockSheets, handleStockMenuClose) => {
  const file = event.target.files[0];
  if (!file) return;
  
  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const text = e.target.result;
      const lines = text.split('\n').filter(line => line.trim());
      const data = lines.slice(1).map(line => {
        const values = line.split(',');
        return {
          enabled: values[0] === 'true',
          width: values[1] || '',
          length: values[2] || '',
          quantity: values[3] || '',
          materialType: values[4] || '',
          grainDirection: values[5] || 'either'
        };
      });
      setStockSheets(data.length > 0 ? data : [{ width: '', length: '', quantity: '', materialType: '', enabled: true, grainDirection: 'either' }]);
    } catch (error) {
      alert('Error importing CSV: ' + error.message);
    }
  };
  reader.readAsText(file);
  event.target.value = null; // Reset input
  handleStockMenuClose();
};

